<template>
  <div class="tree-container">
    <div class="buttons">
      <el-button v-if="show" @click="topNode" size="small" type="primary">添加顶级节点</el-button>
      <el-button @click="exportImg" size="small" type="primary">生成图片</el-button>
      <el-button @click="narrowEnlarge('narrow')" size="small" type="primary">缩小</el-button>
      <el-button @click="narrowEnlarge('enlarge')" size="small" type="primary">放大</el-button>
    </div>
    <div class="orgTree-content" v-if="Object.keys(orgTreeData).length > 0">
      <vue2-org-tree
        v-drag
        name="test"
        ref="imageDom"
        :render-content="renderContent"
        :horizontal="horizontal"
        class="orgTree"
        style="position: absolute"
        id="imageWrapper"
        :data="orgTreeData"
        @on-node-click="nodeClick"
        @on-node-mouseover="onMouseover"
        @on-node-mouseout="onMouseout"
        :label-class-name="labelClassName"/>
    </div>
    <!-- 部门 -->
    <div v-if="basicInfo.type === '0'" v-show="dialogShow" class="dialog" style="box-shadow: 0 2px 12px 2px rgb(235, 238, 245);">
      <div class="title">
        <span style="font-weight: bold;font-size: 14px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-right: 10px">{{basicInfo.departmentName}}</span>
        <i style="font-size:14px;cursor: pointer;" class="el-icon-close cancel" @click="close"></i>
      </div>
      <div class="content">
        <div class="content-item">
          <div class="item-title">部门负责人：</div>
          <span class="lineFeed">{{format(basicInfo.leader)}}</span>
        </div>
        <div class="content-item">
          <div class="item-title">负责人电话：</div>
          <span class="lineFeed">{{format(basicInfo.leaderPhone)}}</span>
        </div>
        <div class="content-item">
          <div class="item-title">部门人数：</div>
          <span class="lineFeed">{{format(basicInfo.departmentNum)}}</span>
        </div>
        <div class="content-item">
          <div class="item-title">部门职责：</div>
          <span class="lineFeed">{{format(basicInfo.departmentDuty)}}</span>
        </div>
      </div>
      <div class="buttonList">
        <el-button size="mini" v-if="show" type="primary" @click="showDialog">添加下级</el-button>
        <el-button size="mini" @click="edit">{{show ? '编辑' : '查看'}}</el-button>
        <el-button size="mini" v-if="show" @click="delTreeNode">删除</el-button>
      </div>
    </div>
    <!-- 个人 -->
    <div v-if="basicInfo.type === '1'" v-show="dialogShow" class="dialog" style="box-shadow: 0 2px 12px 2px rgb(235, 238, 245);">
      <div class="title">
        <span style="font-weight: bold;font-size: 14px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-right: 10px">{{basicInfo.leader}}</span>
        <i style="font-size:14px;cursor: pointer;" class="el-icon-close cancel" @click="close"></i>
      </div>
      <div class="content">
        <div class="content-item">
          <div class="item-title2">岗位：</div>
          <span class="lineFeed">{{basicInfo.departmentName}}</span>
        </div>
        <div class="content-item">
          <div class="item-title2">电话：</div>
          <span class="lineFeed">{{basicInfo.leaderPhone}}</span>
        </div>
        <div class="content-item">
          <div class="item-title2">职责：</div>
          <span class="lineFeed">{{basicInfo.departmentDuty}}</span>
        </div>
      </div>
      <div class="buttonList">
        <el-button size="mini" v-if="show" type="primary" @click="showDialog">添加下级</el-button>
        <el-button size="mini" @click="edit">{{show ? '编辑' : '查看'}}</el-button>
        <el-button size="mini" v-if="show" @click="delTreeNode">删除</el-button>
      </div>
    </div>
    <!-- 移入提示 -->
    <div ref="barParent" v-if="basicSwitch" class="floating">
      <div class="icon-content">
        <span>部门职责:{{info.type === '0' ? info.departmentName : info.leader}}</span>
        <i class="el-icon-caret-left icon"></i>
      </div>
    </div>
    <!-- 弹窗表单 -->
    <el-dialog @close="closeDialog" :title="title" :visible.sync="dialogVisible" width="60%" >
      <template>
        <el-form ref="verification" label-width="95px" :model="formData" :rules="rules">
          <el-row>
            <el-col :span="24">
              <el-form-item label="选择类型">
                <el-radio-group @change="selectType" v-model="radio">
                  <el-radio label="0">部门</el-radio>
                  <el-radio label="1">个人</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 部门 -->
          <div v-if="radio === '0'">
            <el-row>
              <el-col :span="24">
                <el-form-item label="部门名称" prop="departmentName">
                  <el-input v-model="formData.departmentName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="部门负责人">
                  <el-input v-model="formData.leader"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="负责人电话">
                  <el-input type="number" v-model="formData.leaderPhone"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="部门人数">
                  <el-input v-model="formData.departmentNum"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="排序号" prop="orderNum">
                  <el-input type="number" v-model="formData.orderNum"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item class="color" label="颜色" prop="bgColor">
                  <div style="display: flex">
                    <el-input style="" v-model="formData.bgColor"></el-input>
                    <el-color-picker v-model="formData.bgColor"></el-color-picker>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="文字方向" prop="style">
                  <el-select style="width: 100%;" v-model="formData.style" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="部门职责">
                  <el-input type="textarea" v-model="formData.departmentDuty"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="描述">
                  <quill-editor
                    class="ql-editor"
                    v-model="formData.describe"
                    ref="myQuillEditor"
                    :options="editorOption"
                    @blur="onEditorBlur($event)"
                    @focus="onEditorFocus($event)"
                    @change="onEditorChange($event)">
                  </quill-editor>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!-- 个人 -->
          <div v-else>
            <el-row>
              <el-col :span="12">
                <el-form-item label="姓名" prop="leader">
                  <el-input v-model="formData.leader"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话">
                  <el-input type="number" v-model="formData.leaderPhone"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="岗位">
                  <el-input v-model="formData.departmentName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="排序号" prop="orderNum">
                  <el-input  type="number" v-model="formData.orderNum"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item class="color" label="颜色" prop="bgColor">
                  <div style="display: flex">
                    <el-input style="" v-model="formData.bgColor"></el-input>
                    <el-color-picker v-model="formData.bgColor"></el-color-picker>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="文字方向" prop="style">
                  <el-select style="width: 100%;" v-model="formData.style" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="职责">
                  <el-input type="textarea" v-model="formData.departmentDuty"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="描述">
                  <quill-editor
                    class="ql-editor"
                    v-model="formData.describe"
                    ref="myQuillEditor"
                    :options="editorOption"
                    @blur="onEditorBlur($event)"
                    @focus="onEditorFocus($event)"
                    @change="onEditorChange($event)">
                  </quill-editor>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" v-if="show" @click="cancel">取 消</el-button>
        <el-button size="small" v-if="show" type="primary" @click="transmitData">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import html2canvas from 'html2canvas';
import {quillEditor} from 'vue-quill-editor'
export default {
  name: "atdOrgTree",
  // 注册组件
  components: {
    html2canvas,
    quillEditor
  },
  props:{
    show: {
      type: Boolean,
      default:true
    },
    pid: [String, Number],
    horizontal:{
      type: Boolean,
      default:true
    }
  },
  watch:{
    pid:{
      handler(oldVal,newVal) {
        this.getTreeData()
      },
      deep:true,
      immediate:true
    }
  },
  // 开启拖拽的指令
  directives: {
    drag: {
      // 指令的定义
      bind: function (el) {
        const odiv = el // 获取当前元素
        odiv.onmousedown = (e) => {
          // 算出鼠标相对元素的位置
          const disX = e.clientX - odiv.offsetLeft
          const disY = e.clientY - odiv.offsetTop
          document.onmousemove = (e) => {
            // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
            const left = e.clientX - disX
            const top = e.clientY - disY
            // 移动当前元素
            odiv.style.left = left + 'px'
            odiv.style.top = top + 'px'
          }
          document.onmouseup = (e) => {
            document.onmousemove = null
            document.onmouseup = null
          }
        }
      }
    }
  },
  data() {
    return {
      typeName:'添加',
      orgTreeData: {},
      title:'施工组织信息',
      dialogShow:false,
      basicSwitch:false,
      basicInfo:{},
      // 背景颜色
      labelClassName:"bg-color-orange",
      dialogVisible: false,
      //对话框数据
      formData:{
        departmentName: '',
        leader: '',
        leaderPhone: '',
        departmentNum: '',
        orderNum: '',
        bgColor:'#5d87a6',
        type:'',
        departmentDuty:'',
        describe:'',
        style:'H'
      },
      color1: '#5d87a6',
      //表单验证
      rules: {
        departmentName: [{ required: true, message: "字段不能为空", trigger: "blur" }],
        leader: [{ required: true, message: "字段不能为空", trigger: "blur" }],
        orderNum: [{ required: true, message: "字段不能为空", trigger: "blur" }],
        bgColor: [{ required: true, message: "字段不能为空", trigger: "blur" }],
        type: [{ required: true, message: "字段不能为空", trigger: "blur" }],
        style: [{ required: true, message: "字段不能为空", trigger: "blur" }],
      },
      radio: '0',
      info:'',
      rectLeft:'',
      rectTop:'',
      mouseoverLeft:'',
      mouseoverTop:'',

      // 排列方式
      options: [{
        value: 'H',
        label: '横向'
      }, {
        value: 'V',
        label: '竖向'
      }],
      value: '',
      value2:'',
      scal:1,
      content:null,
      editorOption:{
        modules:{
          toolbar:[
            ['bold', 'italic', 'underline', 'strike'],    //加粗，斜体，下划线，删除线
            ['blockquote', 'code-block'],     //引用，代码块
            [{ 'header': 1 }, { 'header': 2 }],        // 标题，键值对的形式；1、2表示字体大小
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],     //列表
            [{ 'script': 'sub'}, { 'script': 'super' }],   // 上下标
            [{ 'indent': '-1'}, { 'indent': '+1' }],     // 缩进
            [{ 'direction': 'rtl' }],             // 文本方向
            [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],     //几级标题
            [{ 'color': [] }, { 'background': [] }],     // 字体颜色，字体背景颜色
            [{ 'font': [] }],     //字体
            [{ 'align': [] }],    //对齐方式
            ['clean'],    //清除字体样式
            // ['image','video']    //上传图片、上传视频
            ['image']    //上传图片、上传视频
          ]
        }
      }
    }
  },
  created() {
    this.getTreeData()
  },
  methods: {
    // 获取数据
    getTreeData() {
      this.$axios.get(`/api/checkwork/orgDepartmentBase/getDepartmentChart?pid=${this.pid}`).then( res => {
        this.orgTreeData = res.data
      })
    },
    // 顶级节点
    topNode() {
      this.radio = '0';
      this.typeName = '顶级'
      this.title = '施工组织信息'
      this.dialogVisible = true;
      this.formData = {
        departmentName: '',
        leader: '',
        leaderPhone: '',
        departmentNum: '',
        orderNum: '',
        bgColor:'#5d87a6',
        type:this.radio,
        departmentDuty:'',
        describe:'',
        style:'H'
      };
      this.formData.parentId = ''
      this.setTips()
    },
    // 鼠标单击节点
    nodeClick(e,data){
      let dialog =  document.getElementsByClassName('dialog')[0];
      this.radio = data.type
      if(data === this.basicInfo ) {
        this.basicInfo = data;
        this.dialogShow = !this.dialogShow;
        dialog.style.top = '';
        dialog.style.left = '';
        if (this.dialogShow) { this.getNodeInfo(e) }
      } else {
        this.dialogShow = true;
        this.basicInfo = data;
        this.getNodeInfo(e)
      }
    },
    // 跟随移动的方法
    getNodeInfo(e) {
      this.$nextTick(() => {
        let dialog =  document.getElementsByClassName('dialog')[0];
        let top = dialog.style.top
        let left = dialog.style.left
        if (!!top && !!left) {
          dialog.style.transition = 'all 0.3s'
        } else {
          dialog.style.transition = 'none'
        }
        // 获取的是父级元素
        const rect = e.currentTarget.getBoundingClientRect()
        console.log(rect);
        this.rectLeft = rect.left;
        this.rectTop = rect.top + rect.height;
        // 浏览器宽度
        let width = document.body.clientWidth;
        // 改变left位置
        let atr = width - rect.left;
        let elWidth = dialog.clientWidth;
        if(atr < elWidth) { this.rectLeft = rect.left - elWidth + rect.width}
        // 浏览器高度
        let height = document.body.clientHeight;
        // 改变Top位置
        let atr2 = height - rect.top;
        let elHeight = dialog.clientHeight;
        if(atr2 < elHeight) { this.rectTop = rect.top - elHeight}
        // 设置位置
        dialog.style.left = this.rectLeft +'px';
        dialog.style.top = this.rectTop  +'px';
      })
    },
    // 鼠标移出节点
    onMouseout(e, data) {
      // this.basicSwitch = false
    },
    // 鼠标移入节点
    onMouseover(e, data) {
      e.target.style.cursor = 'pointer'
      // this.basicSwitch = false;
      // this.$nextTick(() => {
      //   this.basicSwitch = true;
      //   this.$nextTick(() => {
      //     this.info = data;
      //     let floating =  document.getElementsByClassName('floating')[0];
      //     let mouseover = e.currentTarget.getBoundingClientRect()
      //     this.mouseoverLeft = mouseover.left + mouseover.width + 20;
      //     this.mouseoverTop = mouseover.top + 5;
      //     // 浏览器宽度
      //     let width = document.body.clientWidth;
      //     let atr = width - mouseover.left - mouseover.width
      //     let elWidth = floating.offsetWidth + 20;
      //     let aee = this.$refs.barParent.getBoundingClientRect().width
      //     if (aee === 80) { }
      //     let icon =  document.getElementsByClassName('icon')[0];
      //     if(atr < elWidth) {
      //       this.mouseoverLeft = mouseover.left - mouseover.width - 35
      //       icon.style.transform = 'rotate(180deg)'
      //       icon.style.left = 'auto'
      //       icon.style.right = '-18px'
      //     } else {
      //       icon.style.transform = 'none'
      //       icon.style.left = '-18px'
      //     }
      //     floating.style.left = this.mouseoverLeft +'px';
      //     floating.style.top =  this.mouseoverTop +'px';
      //     e.target.style.cursor = 'pointer'
      //   })
      // })
    },
    // 默认渲染节点
    renderContent(h, data) {
      let obj = ''
      if (data.style === 'H') {
        obj = `width:100%;height:100%;display:block;padding:10px 15px;border-radius:3px;background-color:${data.bgColor};box-sizing: border-box;`
      } else {
        obj = `width:100%;display:block;padding:10px 15px 5px 15px;border-radius:3px;background-color:${data.bgColor};box-sizing: border-box;writing-mode:vertical-rl; letter-spacing: 5px; word-spacing: 5px;`
      }
      return (
        <span style={obj}>
          <dd style="margin:0;font-size:1.6vh;">{data.type === '0' ? data.departmentName : data.leader}</dd>
        </span>
      )
    },
    // 导出图片
    exportImg() {
      this.$nextTick(() => {
        html2canvas(document.getElementById('imageWrapper'),{
          scale:4,      // 放大
          useCORS: true, // 使用CORS从服务器加载图像
          async: false, // 异步解析和呈现元素
          background: "#ffffff", // 背景颜色
          dpi: 300, // 处理模糊问题
        }).then(canvas => {
          const img = canvas.toDataURL("image/jpeg").replace("data:image/jpeg;base64,", "")
          const finalImageSrc = "data:image/jpeg;base64," + img
          // 添加a标签用于下载
          const aElem = document.createElement('a')
          document.body.appendChild(aElem)  // 223kb
          aElem.href  = finalImageSrc
          // 图片下载名
          aElem.download = "组织机构图.jpg"
          aElem.click()
          document.body.removeChild(aElem)
        });
      })
    },
    // 缩小放大
    narrowEnlarge(val) {
      this.$nextTick(() => {
        let imageWrapper = document.getElementById('imageWrapper');
        if(val === 'narrow') {this.scal = (parseFloat(this.scal) - 0.10).toFixed(2);} else {
          this.scal = (parseFloat(this.scal) + 0.10).toFixed(2);
        }
        imageWrapper.style.transform = "scale(" + this.scal + ")";
        imageWrapper.style.transformOrigin = '0 0';
      })
    },
    // 关闭
    close() {
      this.dialogShow = false;
      let dialog =  document.getElementsByClassName('dialog')[0];
      dialog.style.top = '';
      dialog.style.left = '';
    },
    // 添加下级
    showDialog() {
      this.radio = this.basicInfo.type
      if (this.radio === '0') {
        this.title = '施工组织信息'
      } else {
        this.title = '人员信息'
      }
      this.formData = {
        departmentName: '',
        leader: '',
        leaderPhone: '',
        departmentNum: '',
        orderNum: '',
        bgColor:'#5d87a6',
        type:'',
        departmentDuty:'',
        describe:'',
        style:'H',
        parentId:this.basicInfo.id
      };
      this.typeName = '添加'
      this.dialogVisible = true;
      this.setTips()
    },
    // 设置提示
    setTips() {
      const titleConfig = {
        "ql-bold": "加粗" ,
        "ql-color": "颜色",
        "ql-font": "字体",
        "ql-code": "插入代码",
        "ql-italic": "斜体",
        "ql-link": "添加链接",
        "ql-background": "背景颜色",
        "ql-size": "字体大小",
        "ql-strike": "删除线",
        "ql-script": "上标/下标",
        "ql-underline": "下划线",
        "ql-blockquote": "引用",
        "ql-header": "标题",
        "ql-indent": "缩进",
        "ql-list": "列表",
        "ql-align": "文本对齐",
        "ql-direction": "文本方向",
        "ql-code-block": "代码块",
        "ql-formula": "公式",
        "ql-image": "图片",
        "ql-video": "视频",
        "ql-clean": "清除字体样式",
        "ql-upload": "文件"
      };
      this.$nextTick(() => {
        const oToolBar = document.getElementsByClassName('ql-editor')[0]
        const aButton = oToolBar.querySelectorAll('button');
        const aSelect =  oToolBar.querySelectorAll('select');
        aButton.forEach(function(item){
          if(item.className === 'ql-script'){
            item.value === 'sub' ? item.title = '下标': item.title = '上标';
          }else if(item.className === 'ql-indent'){
            item.value === '+1' ? item.title ='向右缩进': item.title ='向左缩进';
          }else{
            item.title = titleConfig[item.classList[0]];
          }
        });
        aSelect.forEach(function(item){
          item.parentNode.title = titleConfig[item.classList[0]];
        });
      })
    },
    // 选择类型
    selectType(val) {
      if (val === '0') {
        this.title = '施工组织信息'
      } else {
        this.title = '人员信息'
      }
      if(this.typeName === '添加' || this.typeName === '顶级') {
        this.formData = {
          departmentName: '',
          leader: '',
          leaderPhone: '',
          departmentNum: '',
          orderNum: '',
          bgColor:'#5d87a6',
          type:this.radio,
          departmentDuty:'',
          describe:'',
          style:'H',
          parentId:this.basicInfo.id
        };
      }
      if(this.typeName === '编辑') {
        if(this.radio !== this.basicInfo.type){
          this.formData = {
            departmentName: '',
            leader: '',
            leaderPhone: '',
            departmentNum: '',
            orderNum: '',
            bgColor:'#5d87a6',
            type:this.radio,
            departmentDuty:'',
            describe:'',
            style:'H',
            pid:this.basicInfo.pid,
            departmentId:this.basicInfo.id,
          };
        } else if(this.radio === this.basicInfo.type) {
          this.formData = {
            departmentName: this.basicInfo.departmentName,
            leader: this.basicInfo.leader,
            leaderPhone: this.basicInfo.leaderPhone,
            departmentNum: this.basicInfo.departmentNum !== 'null' ? this.basicInfo.departmentNum : '',
            orderNum: this.basicInfo.orderNum,
            bgColor:this.basicInfo.bgColor,
            type:this.basicInfo.type,
            departmentDuty:this.basicInfo.departmentDuty,
            describe:this.basicInfo.describe,
            style:this.basicInfo.style,
            pid:this.basicInfo.pid,
            departmentId:this.basicInfo.id,
          };
        }
      }
      this.$refs.verification.resetFields();
    },
    // 编辑
    edit() {
      this.radio = this.basicInfo.type
      if (this.radio === '0') {
        this.title = '施工组织信息'
      } else {
        this.title = '人员信息'
      }
      this.dialogVisible = true;
      this.formData = {
        departmentName: this.basicInfo.departmentName,
        leader: this.basicInfo.leader,
        leaderPhone: this.basicInfo.leaderPhone,
        departmentNum: this.basicInfo.departmentNum !== 'null' ? this.basicInfo.departmentNum : '',
        orderNum: this.basicInfo.orderNum,
        bgColor:this.basicInfo.bgColor,
        type:this.basicInfo.type,
        departmentDuty:this.basicInfo.departmentDuty,
        describe:this.basicInfo.describe,
        style:this.basicInfo.style,
        pid:this.basicInfo.pid,
        departmentId:this.basicInfo.id,
      };
      this.typeName = '编辑'
      this.setTips()
    },
    // 弹窗确认
    transmitData() {
      this.$refs.verification.validate((valid) => {
        if (valid) {
          this.formData.pid = this.pid
          this.formData.type = this.radio
          this.$axios.post(`/api/checkwork/orgDepartmentBase/saveContent`,this.$qs.stringify(this.formData)).then( res => {
            if (res.data.success) {
              if (this.typeName !== '顶级') {
                let dialog =  document.getElementsByClassName('dialog')[0];
                dialog.style.top = '';
                dialog.style.left = '';
              }
              this.dialogVisible = false
              this.dialogShow = false
              this.getTreeData()
              this.$message({type: 'success', message: '保存成功!'});
            } else {
              return  this.$message({type: 'warning', message: res.data.message});
            }
          })
        } else {
          return false;
        }
      });
    },
    // 弹窗取消
    cancel() {
      this.formData = {
        departmentName: '',
        leader: '',
        leaderPhone: '',
        departmentNum: '',
        orderNum: '',
        bgColor:'#5d87a6',
        type:'',
        departmentDuty:'',
        describe:'',
        style:'H'
      }
      this.dialogVisible = false
    },
    // 删除
    delTreeNode() {
      this.$confirm('此操作将永久删除该节点, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.delete(`/api/checkwork/orgDepartmentBase/subDelContent?departmentId=${this.basicInfo.id}`).then( res => {
          if (res.data.success) {
            this.$message({type: 'success', message: '删除成功!'});
            this.getTreeData()
            let dialog =  document.getElementsByClassName('dialog')[0];
            dialog.style.top = '';
            dialog.style.left = '';
            this.dialogShow = false
          } else {
            return  this.$message({type: 'warning', message: res.data.message});
          }
        })
      }).catch(() => {
        this.$message({type: 'info', message: '已取消删除'});
      });
    },
    // 关闭弹窗
    closeDialog() {
      this.$refs.verification.resetFields();
    },
    // 富文本事件失去焦点事件
    onEditorBlur(e){
      console.log(e, '失去焦点事件');
    },
    // 富文本事件获得焦点事件
    onEditorFocus(e){
      console.log(e, '获得焦点事件');
    },
    // 富文本事件内容改变事件
    onEditorChange(e){
      console.log(e, '内容改变事件');
    },
    // null格式化
    format(data) {
      console.log(data);
      if (!!data && data !== 'null') {
        return data
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="less">
@import 'atdOrgTree.less';

.tree-container {
  height: calc(100% - 20px);
  .orgTree-content {
    display: flex;
    position: relative;
    justify-content: center;
    height: calc(100% - 10px);
    overflow: hidden;
    .orgTree {
      transform: scale(1);
    }
  }
  .dialog{
    width: 300px;
    position: fixed;
    background-color: #fff;
    border-radius: 5px;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    box-sizing: border-box;
    left:0;
    top: 0;
    transition: all 0.3s;
    z-index: 999;
    text-align: left;
    font-size: 14px;
    .title {
      align-items: center;
      display: flex;
      justify-content: space-between;
      padding: 10px;
      border-bottom: 1px solid #D3D3D3;
      .cancel:hover {
        color: #409EFF;
        cursor: pointer;
      }
    }
    .content {
      padding:10px;
      .content-item {
        display: flex;
        font-size:14px;
        padding: 2px 0px;
        .item-title {
          width: 90px;
          text-align: right;
        }
        .item-title2 {
          width: 50px;
          text-align: right;
        }
        .lineFeed {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2; //控制行数
          -webkit-box-orient: vertical;
        }
      }
    }
    .buttonList {
      padding: 0 10px 10px 5px;
      display: flex;
      justify-content: flex-end;
    }
  }

  .bg-color-orange{
    color: #fff;
    background-color: #5d87a6;
  }

  .floating{
    background: #4c4c4c;
    min-width: 80px;
    //min-height: 30px;
    display: flex;
    align-items: center;
    position: fixed;
    color: #fff;
    border-radius: 5px;
    padding: 6px;
    box-sizing: border-box;
    z-index: 999;
    font-size: 12px;
    .icon-content {
      position: relative;
      display: flex;
      align-items: center;
      .icon {
        position: absolute;
        color: #4c4c4c;
        font-size: 22px;
        left: 0;
      }
    }
  }
}
</style>

<style scoped>
/deep/ .el-dialog__body {
  padding: 20px 20px 0px 20px;
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid #d3d3d3;
}
/deep/ .el-row {
  margin-bottom: 0;
}
/deep/ .ql-container.ql-snow{
  height:200px;
}
/deep/ .ql-editor {
  padding: 0;
  white-space:normal;
}
/deep/ .org-tree-node-label .org-tree-node-label-inner {
  padding: 0;
  text-align: center;
  border-radius: 3px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15);
  /* border: 1px solid @colors;*/
  overflow: hidden;
  box-sizing: border-box;
}
/deep/ .org-tree-container{
  position: absolute;     /*定位*/
  top: 0;
  left: 0;
}
*{
  -webkit-touch-callout:none;  /*系统默认菜单被禁用*/
  -webkit-user-select:none; /*webkit浏览器*/
  -khtml-user-select:none; /*早期浏览器*/
  -moz-user-select:none;/*火狐*/
  -ms-user-select:none; /*IE10*/
  user-select:none;
}
input{
  -webkit-user-select:auto; /*webkit浏览器*/
}
textarea{
  -webkit-user-select:auto; /*webkit浏览器*/
}
</style>



// WEBPACK FOOTER //
// src/components/orgTree/orgTree.vue